import { isHeadless } from '../../../../headless';
import { createEditor as createDefaultEditor } from './default';

const create = createDefaultEditor;

export const createEditor = ((...args: Parameters<typeof create>) => {
  if (isHeadless()) {
    args[0].classList.add('headless');
    document.body.style.overflow = 'hidden';
  }
  return create.apply(this, args);
}) as typeof create;
